import type { PromptWorkType } from '@/types/prompts';

import { PromptGroupIcon } from './PromptGroupIcon';

type PromptMenuHeaderProps = {
  label: string;
  iconUrl?: string;
  lucideIcon?: string;
  /** The group's type of work: tints its icon. */
  workType?: PromptWorkType;
  /** "← back"; left out when there is nowhere to go back to. */
  onBack?: () => void;
};

/**
 * The prompt menu's top row in place of a search: a drilled-in group, or a
 * template's fill step, with "← back".
 */
export function PromptMenuHeader({
  label,
  iconUrl,
  lucideIcon,
  workType,
  onBack,
}: PromptMenuHeaderProps) {
  return (
    <div className='prompt-menu__header' data-cy='prompt-menu-header'>
      {(lucideIcon || iconUrl) && (
        <span className='prompt-menu__header-icon'>
          <PromptGroupIcon
            lucideIcon={lucideIcon}
            iconUrl={iconUrl}
            workType={workType}
          />
        </span>
      )}
      <span className='prompt-menu__header-label' title={label}>
        {label}
      </span>
      {onBack && (
        <button type='button' className='prompt-menu__back' onClick={onBack}>
          ← back
        </button>
      )}
    </div>
  );
}
